import React, { useCallback, useRef } from 'react';
import { BREAKPOINTS } from 'constants/breakpoints';
import useMediaQuery from 'hooks/useMediaQuery';
import useSideMenuStore from 'store/useSideMenuStore';
import DevUserSwitcher from 'components/Dev/DevUserSwitcher';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import NavDrawer from './NavDrawer';
import styles from './AppShell.module.scss';

export interface IAppShellProps {
  children: React.ReactNode;
}

export default function AppShell({ children }: IAppShellProps) {
  const isMdUp = useMediaQuery(`(min-width: ${BREAKPOINTS.md}px)`);
  const drawerOpen = useSideMenuStore(s => s.show);
  const openDrawer = useSideMenuStore(s => s.open);
  const hideDrawer = useSideMenuStore(s => s.hide);
  const menuButtonRef = useRef<HTMLButtonElement>(null);

  const handleOpenMenu = useCallback(() => {
    openDrawer();
  }, [openDrawer]);

  const handleCloseDrawer = useCallback(() => {
    hideDrawer();
  }, [hideDrawer]);

  return (
    <div className={styles.shell}>
      <DevUserSwitcher />

      {isMdUp ? (
        <div className={styles.sidebarSlot}>
          <Sidebar />
        </div>
      ) : (
        <>
          <TopBar
            onOpenMenu={handleOpenMenu}
            menuButtonRef={menuButtonRef}
          />
          <NavDrawer
            open={drawerOpen}
            onClose={handleCloseDrawer}
            returnFocusRef={menuButtonRef}
          />
        </>
      )}

      <div className={styles.mainColumn}>
        <main className={styles.main}>{children}</main>
      </div>
    </div>
  );
}
